module.exports = __webpack_public_path__ + "img/2fa_border.3bdbbc5f.svg";